import React from 'react';
import PropTypes from 'prop-types';


// Container for closing an element (e.g. a modal) when a scroll is detected
// on the window. Adapted from: https://stackoverflow.com/a/42234988
export default class ScrollToDismiss extends React.Component {
	static propTypes = {
		closeAtDistance: PropTypes.number.isRequired,
		onClose: PropTypes.func.isRequired,
		children: PropTypes.element.isRequired,
	};

	componentDidMount() {
		document.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.handleScroll);
	}

	setWrapperRef = node => {
		this.wrapperRef = node;
	};

	handleScroll = e => {
		if (window.pageYOffset > this.props.closeAtDistance) this.props.onClose();
	};

	render() {
		return <div ref={this.setWrapperRef}>{this.props.children}</div>;
	}

}
